'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Node2 = require('./widgets/Node');

var _Node3 = _interopRequireDefault(_Node2);

var _widgets = require('./types/widgets');

var _konsul = require('./types/konsul');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetRegisterContract = _widgets.WidgetRegisterContract;
var KonsulOptions = _konsul.KonsulOptions;


var defaultOptions = {
  clear: true,
  renderDebounce: 10
};

if (!KonsulOptions(defaultOptions)) {
  throw new TypeError('Value of variable "defaultOptions" violates contract.\n\nExpected:\nKonsulOptions\n\nGot:\n' + _inspect(defaultOptions));
}

var Konsul = function (_Node) {
  _inherits(Konsul, _Node);

  function Konsul() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Konsul);

    if (!KonsulOptions(options)) {
      throw new TypeError('Value of argument "options" violates contract.\n\nExpected:\nKonsulOptions\n\nGot:\n' + _inspect(options));
    }

    var _this = _possibleConstructorReturn(this, (Konsul.__proto__ || Object.getPrototypeOf(Konsul)).call(this, null, null));

    _this.rendered = false;


    _this.options = _extends({}, defaultOptions, options);

    if (!KonsulOptions(_this.options)) {
      throw new TypeError('Value of "this.options" violates contract.\n\nExpected:\nKonsulOptions\n\nGot:\n' + _inspect(_this.options));
    }

    _this.registerListeners();
    return _this;
  }

  _createClass(Konsul, [{
    key: 'render',
    value: function render() {
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!(typeof clear === 'boolean')) {
        throw new TypeError('Value of argument "clear" violates contract.\n\nExpected:\nboolean\n\nGot:\n' + _inspect(clear));
      }

      this.rendered = true;

      if (this.options.clear && clear) {
        this.clear();
      }

      this.children.forEach(function (element) {
        element.render();
      });
    }
  }, {
    key: 'requestRender',
    value: function requestRender() {
      var _this2 = this;

      if (!this.rendered || this.lastTime === 0) {
        return;
      }

      this.lastTime = Date.now();

      if (!(typeof this.lastTime === 'number')) {
        throw new TypeError('Value of "this.lastTime" violates contract.\n\nExpected:\nnumber\n\nGot:\n' + _inspect(this.lastTime));
      }

      setTimeout(function () {
        _this2.lastTime = 0;
        _this2.render();
      }, this.options.renderDebounce);
    }
  }, {
    key: 'clear',
    value: function clear() {
      console.clear();
    }
  }, {
    key: 'registerWidget',
    value: function registerWidget(registration) {
      var _this3 = this;

      if (!WidgetRegisterContract(registration)) {
        throw new TypeError('Value of argument "registration" violates contract.\n\nExpected:\nWidgetRegisterContract\n\nGot:\n' + _inspect(registration));
      }

      var name = registration.name,
          Widget = registration.widget;

      if (typeof this[name] !== 'undefined') {
        throw new Error('\'' + name + '\' widget has already been registered');
      }

      var mapOptions = registration.options ? registration.options : {};

      if (!(mapOptions instanceof Object)) {
        throw new TypeError('Value of variable "mapOptions" violates contract.\n\nExpected:\nObject\n\nGot:\n' + _inspect(mapOptions));
      }

      this[name] = function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (!(options instanceof Object)) {
          throw new TypeError('Value of argument "options" violates contract.\n\nExpected:\nObject\n\nGot:\n' + _inspect(options));
        }

        var element = new Widget(_this3);

        Object.keys(options).forEach(function (key) {
          if (mapOptions[key]) {
            mapOptions[key](options[key], element);
          }
        });

        return element;
      };
    }
  }, {
    key: 'registerListeners',
    value: function registerListeners() {
      var _this4 = this;

      this.addListener('shouldRender', function () {
        _this4.requestRender();
      });
    }
  }]);

  return Konsul;
}(_Node3.default);

exports.default = Konsul;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : _typeof(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = Object.keys(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : JSON.stringify(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ../lib/Konsul.js
// module id = 100
// module chunks = 0